// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__kDtA-","upload":"Small_upload__3QBIs","imageWrap":"Small_imageWrap__2ECbx","removeBtn":"Small_removeBtn__3kkpL"};